// extracted by mini-css-extract-plugin
export var sliderRange = "_q8-2";
export var sliderRoot = "_q8-0";
export var sliderThumb = "_q8-3";
export var sliderTrack = "_q8-1";